/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_OtherInputs */



/**

* @param {Footer_OtherInputs} inputs
* @param {{ locale?: "es" }} options
* @returns {LocalizedString}
*/
export const footer_other = /** @type {((inputs?: Footer_OtherInputs, options?: { locale?: "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_OtherInputs, { locale?: "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Otros")
});